/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import { captureException } from '@sentry/react';
import { pick } from 'lodash';

import { getIdToken } from 'src/utils/local-storage-versioning';

import { appConfig } from '../app';

import { StudentBookingErrorResponse } from './types';

export const studentBookingClient = axios.create({
    baseURL: appConfig.backend,
});

const captureAxiosError = (error: unknown) => {
    if (axios.isAxiosError(error)) {
        const { response } = error;

        const data = response?.data as StudentBookingErrorResponse;
        const message = data?.message;

        error.name = 'Student Booking client';

        // Token expired
        if (message === 'Auth token expired') {
            return Promise.reject(error);
        }

        if (message) {
            error.message = message;
        }

        captureException(error, {
            extra: {
                request: pick(response?.config, ['data', 'url', 'method', 'headers']),
                response: data,
            },
        });
    } else {
        captureException(error);
    }

    return Promise.reject(error);
};

studentBookingClient.interceptors.request.use((config) => {
    const token = getIdToken();

    if (token) {
        // Attach the token to the Authorization header
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, captureAxiosError);
studentBookingClient.interceptors.response.use(undefined, captureAxiosError);
